module.exports = __webpack_public_path__ + "img/main-hero-0.0b6969cc.jpg";